import dayjs from "dayjs";
import { PRIZE_ROWS, PRIZE_SLOT_COUNTS, REGION_META } from "../XoSoCompound/constants";

export default function CompactResultTable({
  region,
  results = [],
  date,
  loading = false,
  liveDrawing = false,
}) {
  const meta = REGION_META[region];
  const slots = PRIZE_SLOT_COUNTS[region] || {};
  const rows = PRIZE_ROWS.filter((row) => !row.regions || row.regions.includes(region)).map(
    (row) => {
      if (region === "MB" && row.key === "prize7") return { ...row, size: "xl" };
      return row;
    }
  );
  const multi = results.length > 1;

  return (
    <div className={`xoso-sidebar-kq${loading ? " is-loading" : ""}${liveDrawing ? " is-live" : ""}`}>
      {!loading && !results.length ? (
        <div className="xoso-sidebar-kq__empty">
          Chưa có KQ {dayjs(date).format("DD/MM")}
        </div>
      ) : (
        <div className="xoso-sidebar-kq__scroll">
          <table className="xoso-sidebar-kq__table">
            {multi ? (
              <thead>
                <tr>
                  <th key="label" className="xoso-sidebar-kq__corner">{meta.short}</th>
                  {results.map((item, i) => (
                    <th key={item.province?.code || item.id || i}>{item.province?.name}</th>
                  ))}
                </tr>
              </thead>
            ) : null}
            <tbody>
              {rows.map((row) => (
                <tr key={row.key} className={`xoso-sidebar-prize xoso-sidebar-prize--${row.size}`}>
                  <td key="label" className="xoso-sidebar-prize__label">{row.shortLabel}</td>
                  {(results.length ? results : [{ prizes: {} }]).map((item, i) => {
                    const nums = Array.isArray(item?.prizes?.[row.key]) ? item.prizes[row.key] : [];
                    const spinning = liveDrawing && nums.length < (slots[row.key] || 1);
                    return (
                      <td
                        key={item.province?.code || item.id || i}
                        className="xoso-sidebar-prize__value"
                      >
                        {nums.map((num, i) => (
                          <span key={`${num}-${i}`} className="xoso-sidebar-prize__num">
                            {num}
                          </span>
                        ))}
                        {spinning ? <span className="xoso-sidebar-prize__spin" aria-hidden /> : null}
                        {!nums.length && !spinning ? (
                          <span className="xoso-sidebar-prize__num">-</span>
                        ) : null}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
